import React from 'react';

import HierarchyQuotaDistribution from 'app/components/DataTray/HierarchyQuotaDistribution/HierarchyQuotaDistribution';
import QuotaGrid from 'app/components/DataTray/QuotaGrid/QuotaGrid';

import { useBattleCard } from 'app/contexts/battleCardProvider';
import { useGrid } from 'app/contexts/gridProvider';
import { usePlanTargets } from 'app/contexts/planTargetsProvider';
import { useTerritoryDefineAndRefine } from 'app/contexts/territoryDefineAndRefineProvider';

interface QuotaGridContainerProps {
  sheetId?: number;
}

const QuotaGridContainer: React.FC<QuotaGridContainerProps> = ({ sheetId }) => {
  const { selectedBattleCardId } = useBattleCard();
  const { selectedPillIdPlanTargets } = usePlanTargets();
  const { selectedPillIdTDR } = useTerritoryDefineAndRefine();
  const { showHierarchyQuotaDistribution } = useGrid();

  const selectedPillId = selectedPillIdPlanTargets || selectedPillIdTDR;

  if (!selectedBattleCardId && !selectedPillId) {
    return null;
  } else if (showHierarchyQuotaDistribution) {
    return <HierarchyQuotaDistribution quotaSheetId={sheetId} />;
  }

  return <QuotaGrid sheetId={sheetId} />;
};

export default QuotaGridContainer;
